export const ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/redefinir-senha',
  ONBOARDING: '/onboarding',
  APP: {
    ROOT: '/app',
    MATCHES: '/app/matches',
    MATCH_DETAIL: (id: string) => `/app/matches/${id}`,
    CHAT: '/app/chat',
    CHAT_CONVERSATION: (matchId: string) => `/app/chat/${matchId}`,
    CRM: '/app/crm',
    MENTOR: '/app/mentor',
    PROFILE: '/app/profile',
    NOTIFICATIONS: '/app/notifications',
  },
} as const;

export const STORAGE_KEYS = {
  AUTH: 'kh-match:auth',
  ONBOARDING_DRAFT: 'kh-match:onboarding-draft',
} as const;

export const QUERY_KEYS = {
  ME: ['auth', 'me'] as const,
  MATCHES: ['matches'] as const,
  CONVERSATIONS: ['conversations'] as const,
  MESSAGES: (matchId: string) => ['messages', matchId] as const,
  TAGS: ['tags'] as const,
  EVENT_ACTIVE: ['event', 'active'] as const,
  CRM_ENTRIES: ['crm', 'entries'] as const,
} as const;

export const PAGINATION = {
  DEFAULT_LIMIT: 20,
  MAX_LIMIT: 100,
} as const;
